import { forwardRef } from "react"

import TextareaAutosize, { TextareaAutosizeProps } from "react-textarea-autosize"

import { Input } from "./Input"

export interface TextareaProps extends TextareaAutosizeProps {
  isError?: boolean
  rootClassName?: string
}

export const Textarea = forwardRef(function Textarea(
  {
    isError,
    className,
    rootClassName,
    minRows,
    maxRows,
    ...textareaProps
  }: TextareaProps,
  ref: React.Ref<HTMLTextAreaElement>,
) {
  return (
    // @ts-expect-error: spreading more than exists in input but it's fine
    <Input
      aria-invalid={isError}
      className={className}
      aria-disabled={textareaProps.disabled}
      asChild
      rootClassName={rootClassName}
      {...textareaProps}
      onBlur={undefined}
    >
      <TextareaAutosize
        ref={ref}
        minRows={minRows}
        maxRows={maxRows}
        {...textareaProps}
      />
    </Input>
  )
})
